var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code",style:({'width': _vm.width, 'height': _vm.height}),attrs:{"id":"qr-code"}},[_c('canvas',{style:({'width': _vm.width, 'height': _vm.height}),attrs:{"id":"my-canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }